import React, { lazy, Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'
import Layout from 'layouts'
import IndividualVehicle from 'pages/manage/IndividualVehicle'
import IndividualVendor from 'pages/manage/IndividualVendor'

const routes = [
  {
    path: '/login',
    Component: lazy(() => import('pages/auth/login')),
    exact: true,
  },
  {
    path: '/manage/user',
    Component: lazy(() => import('pages/manage/Users')),
    exact: true,
  },
  {
    path: '/manage/vehicle',
    Component: lazy(() => import('pages/manage/Vehicle')),
    exact: true,
  },
  {
    path: '/manage/vendor',
    Component: lazy(() => import('pages/manage/Vendor')),
    exact: true,
  },
  {
    path: '/manage/driver',
    Component: lazy(() => import('pages/manage/Staff')),
    exact: true,
  },
  {
    path: '/manage/services',
    Component: lazy(() => import('pages/manage/Services')),
    exact: true,
  },
  {
    path: '/manage/reports',
    Component: lazy(() => import('pages/manage/Reports')),
    exact: true,
  },
  {
    path: '/manage/fuel',
    Component: lazy(() => import('pages/manage/Fuel')),
    exact: true,
  },
]

const mapStateToProps = ({ settings }) => ({
  routerAnimation: settings.routerAnimation,
})

const Router = ({ history, routerAnimation }) => {
  return (
    <ConnectedRouter history={history}>
      <Layout>
        <Route
          render={state => {
            const { location } = state
            return (
              <SwitchTransition>
                <CSSTransition
                  key={location.pathname}
                  appear
                  classNames={routerAnimation}
                  timeout={routerAnimation === 'none' ? 0 : 300}
                >
                  <Switch location={location}>
                    <Route exact path="/" render={() => <Redirect to="/manage/user" />} />
                    <Route exact path="/manage/vehicle/:id" component={IndividualVehicle} />
                    <Route exact path="/manage/vendor/:id" component={IndividualVendor} />
                    {routes.map(({ path, Component, exact }) => (
                      <Route
                        path={path}
                        key={path}
                        exact={exact}
                        render={() => {
                          return (
                            <div className={routerAnimation}>
                              <Suspense fallback={null}>
                                <Component />
                              </Suspense>
                            </div>
                          )
                        }}
                      />
                    ))}
                    <Redirect to="/404" />
                  </Switch>
                </CSSTransition>
              </SwitchTransition>
            )
          }}
        />
      </Layout>
    </ConnectedRouter>
  )
}

export default connect(mapStateToProps)(Router)
